import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    margin: '8px 0',
    border: `1px solid ${theme.palette.grey[500]}`,
    padding: 16,
    borderRadius: 12
  },
  row: {
    display: 'grid',
    gridTemplateColumns: '3fr 3fr 3fr 2fr',
    gap: 8,
    alignItems: 'flex-end'
  },
  row2: {
    display: 'grid',
    gridTemplateColumns: '3fr 3fr 3fr 2fr',
    gap: 8,
    marginBottom: 16
  },
  title: { fontWeight: 500, fontSize: 18, color: theme.palette.text.primary },
  subTitle: { fontWeight: 500, fontSize: 14 },

  searchInput: {
    marginBottom: 12
  }
}))

export default useStyles
